import { waLink } from "../../lib/brand";

const pieces = [
  {
    name: "Jhumki Payal",
    img: "https://images.pexels.com/photos/33287642/pexels-photo-33287642.jpeg",
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    name: "Oxidised Band",
    img: "https://images.pexels.com/photos/20306795/pexels-photo-20306795.jpeg",
    span: "lg:col-span-5",
  },
  {
    name: "Temple Haar",
    img: "https://images.pexels.com/photos/16109307/pexels-photo-16109307.jpeg",
    span: "lg:col-span-5",
  },
  {
    name: "Filigree Kada",
    img: "https://images.pexels.com/photos/33834689/pexels-photo-33834689.jpeg",
    span: "lg:col-span-4",
  },
  {
    name: "Chandni Pendant",
    img: "https://images.unsplash.com/photo-1767786124293-289dafe6340d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-4",
  },
  {
    name: "Ghungroo Anklet",
    img: "https://images.unsplash.com/photo-1656010280162-772358d9f4ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxzaWx2ZXIlMjByaW5nJTIwamV3ZWxyeXxlbnwwfHx8fDE3NzczMDc4NjV8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-4",
  },
];

export const Featured = () => {
  return (
    <section
      id="featured"
      data-testid="featured-section"
      className="relative py-24 lg:py-32 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-2xl reveal">
            <p className="text-[11px] tracking-[0.4em] uppercase text-zinc-500 mb-5">
              03 — Featured Designs
            </p>
            <h2 className="font-display font-light text-zinc-950 text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Hand‑picked from
              <br />
              <span className="italic text-zinc-600">our current atelier.</span>
            </h2>
          </div>
          <p className="lg:max-w-sm text-zinc-600 leading-relaxed reveal reveal-delay-1">
            A small edit of silver pieces currently in the studio. DM on
            Instagram or WhatsApp for the latest designs in stock.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 lg:gap-6 auto-rows-[280px] lg:auto-rows-[260px]">
          {pieces.map((p, i) => (
            <a
              key={p.name}
              href={waLink(`Hi, I'd like details about the ${p.name}.`)}
              target="_blank"
              rel="noreferrer"
              data-testid={`featured-${i}`}
              className={`group relative overflow-hidden bg-zinc-100 border border-zinc-200 img-zoom-wrap reveal reveal-delay-${
                (i % 4) + 1
              } ${p.span}`}
            >
              <img
                src={p.img}
                alt={p.name}
                className="absolute inset-0 h-full w-full object-cover img-zoom"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
              <div className="absolute left-6 bottom-6 right-6 flex items-end justify-between">
                <div>
                  <div className="text-[10px] tracking-[0.35em] uppercase text-white/80">
                    Silver · Hand‑finished
                  </div>
                  <div className="font-display text-xl lg:text-2xl text-white mt-1">
                    {p.name}
                  </div>
                </div>
                <span className="text-[10px] tracking-[0.3em] uppercase text-white/90 border-b border-white/60 pb-0.5">
                  Enquire
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
